export default __webpack_public_path__ + "static/media/Rjl50.39eba987.png";